import React, { useState } from 'react'
import { Button, Field, Control, Input, Columns, Column, Notification, Delete, Icon } from 'bloomer'
import { useHistory } from 'react-router-dom'
import { CenteredForm } from '../utils/centered-form'

export function RiderForm(props: { rider: RiderFields; onSave: (rider: RiderFields) => Promise<void> }) {
  const [errorMessage, setErrorMessage] = useState('')
  const [rider, setRider] = useState(props.rider)
  const history = useHistory()

  return (
    <CenteredForm
      onSubmit={async (e) => {
        e.preventDefault()
        try {
          await props.onSave({ createdAt: new Date(), ...rider, updatedAt: new Date() })
          history.push('/riders')
        } catch (error) {
          setErrorMessage(error.message)
        }
      }}
    >
      {errorMessage && (
        <Notification isColor="danger">
          <Delete onClick={() => setErrorMessage('')} />
          {errorMessage}
        </Notification>
      )}

      <Field>
        <Control hasIcons="left">
          <Icon className="fas fa-user"></Icon>
          <Input
            value={rider.name}
            onChange={(event: React.FormEvent<HTMLInputElement>) =>
              setRider({ ...rider, name: event.currentTarget.value })
            }
            autoComplete="off"
            placeholder="Name"
            autoFocus
          />
        </Control>
      </Field>

      <Field>
        <Control hasIcons="left">
          <Icon className="fas fa-envelope"></Icon>
          <Input
            value={rider.email}
            onChange={(event: React.FormEvent<HTMLInputElement>) =>
              setRider({ ...rider, email: event.currentTarget.value })
            }
            autoComplete="off"
            type="email"
            placeholder="Email"
          />
        </Control>
      </Field>

      <Field>
        <Columns>
          <Column>
            <Control>
              <Button isFullWidth onClick={() => history.push('/riders')}>
                Cancel
              </Button>
            </Control>
          </Column>
          <Column>
            <Control>
              <Button isColor="primary" isFullWidth type="submit">
                Save Rider
              </Button>
            </Control>
          </Column>
        </Columns>
      </Field>
    </CenteredForm>
  )
}

interface RiderFields {
  email: string
  name: string
  createdAt?: Date
  updatedAt?: Date
}
